module.exports = __webpack_public_path__ + "img/logo-light.56df8ed0.svg";